// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type TopicDetailsForResourceCard_TopicModelAsEditor_Fragment = (
  { __typename?: 'TopicModelAsEditor' }
  & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id' | 'currentTitle' | 'deleted_at' | 'created_at' | 'theme_id'>
  & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
  ), lastEnrolment?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'completion_date' | 'progress' | 'target_completion_date' | 'status'>
  )>, coverImage?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'DocumentModel' }
    & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
    & { imageVariants: Array<(
      { __typename?: 'ImageVariantModel' }
      & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
    )> }
  )> }
);

export type TopicDetailsForResourceCard_TopicModelAsMember_Fragment = (
  { __typename?: 'TopicModelAsMember' }
  & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle' | 'deleted_at' | 'created_at' | 'theme_id'>
  & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
  ), lastEnrolment?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'completion_date' | 'progress' | 'target_completion_date' | 'status'>
  )>, coverImage?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'DocumentModel' }
    & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
    & { imageVariants: Array<(
      { __typename?: 'ImageVariantModel' }
      & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
    )> }
  )> }
);

export type TopicDetailsForResourceCardFragment = TopicDetailsForResourceCard_TopicModelAsEditor_Fragment | TopicDetailsForResourceCard_TopicModelAsMember_Fragment;

export type BookmarkListQueryVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type BookmarkListQuery = (
  { __typename?: 'Query' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & { bookmarkList: Array<(
      { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    ) | (
      { __typename?: 'WorkspaceBookmarkModelAsMember' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsMember, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & { bookmarkList: Array<(
      { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    ) | (
      { __typename?: 'WorkspaceBookmarkModelAsMember' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsMember, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & { bookmarkList: Array<(
      { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    ) | (
      { __typename?: 'WorkspaceBookmarkModelAsMember' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsMember, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    )> }
  )> }
);

export type WorkspaceTopicsAndThemesQueryVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type WorkspaceTopicsAndThemesQuery = (
  { __typename?: 'Query' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id' | 'description' | 'name'>
    & { owner: (
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
    ), coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
      )> }
    )>, topics: Array<(
      { __typename?: 'TopicModelAsEditor' }
      & TopicDetailsForResourceCard_TopicModelAsEditor_Fragment
    ) | (
      { __typename?: 'TopicModelAsMember' }
      & TopicDetailsForResourceCard_TopicModelAsMember_Fragment
    )>, themes: Array<(
      { __typename?: 'ThemeModelAsEditor' }
      & Pick<PrivateSchemaTypes.ThemeModelAsEditor, 'id' | 'title'>
      & { topicsCount: PrivateSchemaTypes.ThemeModelAsEditor['publishedTopicsCount'] }
    ) | (
      { __typename?: 'ThemeModelAsMember' }
      & Pick<PrivateSchemaTypes.ThemeModelAsMember, 'id' | 'title'>
      & { topicsCount: PrivateSchemaTypes.ThemeModelAsMember['publishedTopicsCount'] }
    )>, tags: Array<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id' | 'description' | 'name'>
    & { owner: (
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
    ), coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
      )> }
    )>, topics: Array<(
      { __typename?: 'TopicModelAsEditor' }
      & TopicDetailsForResourceCard_TopicModelAsEditor_Fragment
    ) | (
      { __typename?: 'TopicModelAsMember' }
      & TopicDetailsForResourceCard_TopicModelAsMember_Fragment
    )>, themes: Array<(
      { __typename?: 'ThemeModelAsEditor' }
      & Pick<PrivateSchemaTypes.ThemeModelAsEditor, 'id' | 'title'>
      & { topicsCount: PrivateSchemaTypes.ThemeModelAsEditor['publishedTopicsCount'] }
    ) | (
      { __typename?: 'ThemeModelAsMember' }
      & Pick<PrivateSchemaTypes.ThemeModelAsMember, 'id' | 'title'>
      & { topicsCount: PrivateSchemaTypes.ThemeModelAsMember['publishedTopicsCount'] }
    )>, tags: Array<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id' | 'description' | 'name'>
    & { owner: (
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
    ), coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
      )> }
    )>, topics: Array<(
      { __typename?: 'TopicModelAsEditor' }
      & TopicDetailsForResourceCard_TopicModelAsEditor_Fragment
    ) | (
      { __typename?: 'TopicModelAsMember' }
      & TopicDetailsForResourceCard_TopicModelAsMember_Fragment
    )>, themes: Array<(
      { __typename?: 'ThemeModelAsEditor' }
      & Pick<PrivateSchemaTypes.ThemeModelAsEditor, 'id' | 'title'>
      & { topicsCount: PrivateSchemaTypes.ThemeModelAsEditor['publishedTopicsCount'] }
    ) | (
      { __typename?: 'ThemeModelAsMember' }
      & Pick<PrivateSchemaTypes.ThemeModelAsMember, 'id' | 'title'>
      & { topicsCount: PrivateSchemaTypes.ThemeModelAsMember['publishedTopicsCount'] }
    )>, tags: Array<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
    )> }
  )> }
);

export const TopicDetailsForResourceCardFragmentDoc = gql`
    fragment TopicDetailsForResourceCard on ITopicModel {
  id
  currentTitle
  deleted_at
  created_at
  theme_id
  currentTopicVersion {
    id
    title
    readDurationMins
    summary
  }
  author {
    id
    email
    image_url
    display_name
    profile_img_url
  }
  lastEnrolment {
    id
    completion_date
    progress
    target_completion_date
    status
  }
  coverImage {
    id
    cdnUrl
    imageVariants {
      cdnUrl
    }
  }
}
    `;
export const BookmarkListDocument = gql`
    query bookmarkList($workspaceId: PositiveInt!) {
  workspace(id: $workspaceId) {
    bookmarkList {
      id
      title
      url
      image {
        original
        largeCdnUrl: variantCdnUrl(imageSize: large)
      }
      type
    }
  }
}
    `;

/**
 * __useBookmarkListQuery__
 *
 * To run a query within a React component, call `useBookmarkListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookmarkListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookmarkListQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useBookmarkListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BookmarkListQuery, BookmarkListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BookmarkListQuery, BookmarkListQueryVariables>(BookmarkListDocument, options);
      }
export function useBookmarkListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookmarkListQuery, BookmarkListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BookmarkListQuery, BookmarkListQueryVariables>(BookmarkListDocument, options);
        }
export type BookmarkListQueryHookResult = ReturnType<typeof useBookmarkListQuery>;
export type BookmarkListLazyQueryHookResult = ReturnType<typeof useBookmarkListLazyQuery>;
export type BookmarkListQueryResult = Apollo.QueryResult<BookmarkListQuery, BookmarkListQueryVariables>;
export const WorkspaceTopicsAndThemesDocument = gql`
    query workspaceTopicsAndThemes($workspaceId: PositiveInt!) {
  workspace(id: $workspaceId) {
    id
    description
    name
    owner {
      id
      display_name
    }
    coverImage {
      id
      cdnUrl
      imageVariants {
        cdnUrl
      }
    }
    topics(filters: [{name: withCurrentVersion}]) {
      ...TopicDetailsForResourceCard
    }
    themes {
      id
      title
      topicsCount: publishedTopicsCount
    }
    tags {
      id
      name
    }
    tags {
      id
      name
    }
  }
}
    ${TopicDetailsForResourceCardFragmentDoc}`;

/**
 * __useWorkspaceTopicsAndThemesQuery__
 *
 * To run a query within a React component, call `useWorkspaceTopicsAndThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceTopicsAndThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceTopicsAndThemesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceTopicsAndThemesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceTopicsAndThemesQuery, WorkspaceTopicsAndThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceTopicsAndThemesQuery, WorkspaceTopicsAndThemesQueryVariables>(WorkspaceTopicsAndThemesDocument, options);
      }
export function useWorkspaceTopicsAndThemesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceTopicsAndThemesQuery, WorkspaceTopicsAndThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceTopicsAndThemesQuery, WorkspaceTopicsAndThemesQueryVariables>(WorkspaceTopicsAndThemesDocument, options);
        }
export type WorkspaceTopicsAndThemesQueryHookResult = ReturnType<typeof useWorkspaceTopicsAndThemesQuery>;
export type WorkspaceTopicsAndThemesLazyQueryHookResult = ReturnType<typeof useWorkspaceTopicsAndThemesLazyQuery>;
export type WorkspaceTopicsAndThemesQueryResult = Apollo.QueryResult<WorkspaceTopicsAndThemesQuery, WorkspaceTopicsAndThemesQueryVariables>;